const BASE_URL = process.env.REACT_APP_DGPV_API_URL;
const FACTORY_TOOL_URL = process.env.REACT_APP_FACTORY_TOOL_URL;
const PLATFORM_DEVICES_URL = process.env.REACT_APP_PLATFORM_DEVICES_URL;

const apiUrls = {
  login: `${BASE_URL}/auth/login`,
  refresh: `${BASE_URL}/auth/refresh`,
  logout: `${BASE_URL}/auth/logout`,
  updateDeviceInfo: `${BASE_URL}/device`,
  getAccessToken: `${FACTORY_TOOL_URL}/api/jwt/access-token/`,
  updateDeviceModbus: (deviceId) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/modbus-config/`,
  getModbusData: (modbusId) =>
    `${FACTORY_TOOL_URL}/api/modbus-config/${modbusId}/`,
  getPatchData: (deviceId) => `${FACTORY_TOOL_URL}/api/patch/${deviceId}/`,
  getPatchCode: (patchId) => `${FACTORY_TOOL_URL}/api/patch/${patchId}/`,
  updateInterface: (interfaceId) =>
    `${FACTORY_TOOL_URL}/api/device/interfaces/${interfaceId}/`,
  savePatch: (deviceId) => `${FACTORY_TOOL_URL}/api/device/${deviceId}/patch/`,
  saveDeviceGroupInterface: (deviceId, interfaceId) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/interface/${interfaceId}/`,
  groupAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/attributes?keys=${keys}`,
  toolDeviceAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/${deviceId}/attributes?keys=${keys}`,
  allDevices: (serialNumber, page = 0) =>
    `${PLATFORM_DEVICES_URL}?pageSize=10&page=${page}&textSearch=${serialNumber}&sortProperty=id&sortOrder=DESC`,
  deviceAttributes: (deviceId, keys) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/values/attributes?keys=${keys}`,
  updateDevice: (deviceId) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/SHARED_SCOPE`,
  deviceTsData: (deviceId, start, end, keys) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/values/timeseries?limit=1000&startTs=${start}&endTs=${end}&keys=${keys}`,
  // uploadThresholds expects a modbus-config id (or other id to target) and returns the URL
  uploadThresholds: (modbusConfigId) =>
    `${FACTORY_TOOL_URL}/api/modbus-config/${modbusConfigId}/parameters/`,
  activeDevices: (activeOnly = true) =>
    `${BASE_URL}/deviceProfile/names?activeOnly=${activeOnly}`,

  factorytoolgroupAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/${deviceId}/attributes?keys=${keys}`,
};

export default apiUrls;
